export const FETCH_BAGS = 'FETCH_BAGS'